import { useEffect, useState } from "react";
import { subscribeFreshProducts } from "../../../components/firebase/firestore";

export default function useFreshProducts(link) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setLoading(true);
    setError(false);
    return subscribeFreshProducts((items) => {
      setProducts(items);
      setLoading(false);
    }, () => {
      setProducts([]);
      setError(true);
      setLoading(false);
    }, link);
  }, [attempt, link]);

  return { products, loading, error, retry: () => setAttempt((value) => value + 1) };
}
